__turbopack_context__.v({
  "left": "TwoColumnLayout-module-scss-module__moaTYW__left",
  "main": "TwoColumnLayout-module-scss-module__moaTYW__main",
  "pdf": "TwoColumnLayout-module-scss-module__moaTYW__pdf",
  "right": "TwoColumnLayout-module-scss-module__moaTYW__right",
});
